import React, { Fragment } from "react";
import { Container, Row, Col} from "react-bootstrap";
import { Link } from "react-router-dom";


const OrgAssessment = () => { 

  return( 
    <Fragment>

      <div className="bg-light mx-0 my-0 p-5 rounded-lg" style={{backgroundImage: 'url(/images/hackingCreativity/orgAssessment.jpg)'}}>
        <h1 className="display-3"style={{color:'white'}}>Reimagining High Performance Cultures</h1>
        <h3 className="display-5" style={{color:'white', fontStyle:'italic'}}>Is Your Organization Future Ready?</h3>
      </div> 

      <Container className="border rounded border-primary p-5 m-5">
         <Row className="px-3 mt-3">
            <h3 className="display-4"> High Performance Culture Assessment</h3>
            <p className="lead" style={{color: '#ae7810'}}> Does your company have a high performing, healthy and innovative culture?</p>
            <p> </p>
            <p> Many challenges that companies face today from employee engagement to competitive threats stem from deeper cultural norms that also impact performance and innovation. Use our proprietary <Link to="http://blog.mindantix.com/2023/05/assessing-the-creative-health-of-an-organization/" target="_blank" style={{color:'#244a94', fontWeight:'bold', textDecoration:'underline'}}> innovation-readiness </Link> assessment to start tracking your culture and improving <span style={{color: '#ae7810', fontWeight:'bold'}}> innovation, performance and employee satisfaction. </span></p>
            <ul>
               <li> Research-backed, behavior-focused dimensions </li>
               <li> Additional focus on areas like work characteristics, cognitive collaboration and DEI</li>
               <li> Actionable insights </li>
            </ul>
         </Row>

         <Row className="px-3 mt-3">
            <p><Link className="btn text-white" style={{backgroundColor:'#c87137'}} to="mailto:hello@mindantix.com" role="button">Email us to learn more &raquo;</Link> </p>
         </Row>

      </Container>

      <Container>
         <Row className="mb-1">
            <Col className="col-12">
               <h3 className="display-4">Studies</h3>
               <p className="lead"> We are investigating how different factors like gender bias or the type of work employees engage in impacts innovation and organizational culture. </p>
            </Col>

         </Row>
      </Container>

      <Container className="border rounded border-secondary mb-5">
         <Row className="mt-5 mb-5">
            <Col className="col-12 col-md-5">
               <img className="card-img-top img-fluid"
                  src="/images/hackingCreativity/GenderInnovation-Tech.png"
                  height="100%"
                  width = "100%"
                  alt="Positive Ally"
               />
            </Col>
            <Col className="col-12 col-md-7">
               <h4  style={{color: '#ae7810'}}> How Gender Bias Limits Innovation </h4>
               <p style={{color: '#244a94', fontWeight:'bold'}}> Diverse groups have the potential to be more innovative. <em> But are they in practice? </em> </p>
               <p> We conducted a qualitative research study to see how gender bias impacts women's ability to contribute to organizational innovation in the technology industry. We found that despite DEI efforts, there are significant barriers that women face in driving their ideas which leads to a high cost both for women and their companies.  </p>
               <p> We identified four cognitive and psychological mechanisms underlying the challenges that women face - <em> Evaluation apprehension, Groupthink, Cognitive Dissonance </em> and <em> Tokenism.</em></p>
               <p> Our study offers different strategies leaders and organizations can employ to create healthier environments and mitigate the impact of biases in innovative work. </p>
               <p className="lead"><Link className="btn text-white" style={{backgroundColor:'#ae7810'}} to="/docs/hackingCreativity/GenderInnovation-Tech.pdf" target="_blank" role="button">Read the Full Report &raquo;</Link></p>
      
            </Col>
         </Row>
      </Container>

      <Container className="border rounded border-secondary mb-5">
         <Row className="mt-5 mb-5">
            <Col className="col-12 col-md-5">
               <img className="card-img-top img-fluid"
                  src="/images/hackingCreativity/Routine-NonRoutine-Productivity.png"
                  height="100%"
                  width = "100%"
                  alt="Positive Ally"
               />
            </Col>
            <Col className="col-12 col-md-7">
               <h4  style={{color: '#ae7810'}}> Organizational Culture and Type Of Work </h4>
               <p style={{color: '#244a94', fontWeight:'bold'}}> Unhealthy cultures arise when there is an imbalance beween routine and non-routine (creative) work.</p>
               <p> As an example, when routine productivity expectations are so high that creativity gets pushed out, we get the <em> Hamster Wheel </em> culture. Or, when a high value is placed on visionary ideas but not as much on practicality and execution, it leads to a <em> Pipe Dream </em> culture. </p>
               <p style={{color: '#244a94', fontWeight:'bold'}}> We want to hear from you! Take our short (15min) survey.</p>
               
               <p className="lead"><Link className="btn text-white" style={{backgroundColor:'#ae7810'}} to="https://forms.gle/fbo1zN1mhojd1eYP9" target="_blank" role="button">Go To Survey &raquo;</Link></p>
      
            </Col>
         </Row>
      </Container>
      
      

    </Fragment>
       
  );
};
  
export default OrgAssessment;